
// import 'kpc/styles/kpc.styl';
import pButton, {ButtonGroup} from 'kpc/components/button';
import pRadio from 'kpc/components/radio';
import Tooltip from 'kpc/components/tooltip';
import Slider from 'kpc/components/slider';
import Spinner from 'kpc/components/spinner';
import pForm, {FormItem} from 'kpc/components/form';
import pInput from 'kpc/components/input';
import pSelect, {Option} from 'kpc/components/select';
import TimeSilder from 'ksc-vue-ui2/src/components/KsTimerSlider/index.vue';
import TimeSildertext from 'ksc-vue-ui2/src/components/KsTimerSlidertext/index.vue';
import KsSlider from 'ksc-vue-ui2/src/components/KsSliderBar/index.vue';
import KsSpinner from 'ksc-vue-ui2/src/components/kecSpinner/Spinner.vue';
import * as pcommon from '../../store/common/constants';
import * as step2Const from '../../store/create/step2/constants';
import {mapState} from 'vuex';
import Message from 'kpc/components/message';
import Vue from 'vue';
import _ from 'lodash';
import Card from 'kpc/components/card';

export default {
    data() {
        return {
            isShow: false,
            hasPrecondition: true,
            isBuyEip: 'buyLater',
            isJoinBws: false,
            maxBandwidth: 200,
            minBandwidth: 2,
            step: 1,
            bandwidth: 1,
            // Mbps: ''
            unit: 'Mbps',
            minBuyNum: 1,
            maxBuyNum: 9999,
            billTypeList: [],
            newBillTypeList:[],
            bwsBillTypeList: [],
            newBwsBillTypeList:[],
            billType: '',
            bwsBillType: '',
            lineId: '',
            chooseTimeValue:1,
            // time: 1,
            hasDiscount: true,
            bws: '',
            bwsListWithoutStaticLine: [],
            bwsBandwidth: '',
            bwsLineId: '',
            onTrailDay: 1,
            tailTip: false,
            noConfigBws: false,
            formattedPriceData: {},
            showBwsSelect: true,
            showBuyEipNum: true,
            eipCount: 1,
            SKIP:'',
            marks: {
                '1': ['1', Vue.$trans(`{0}个月`, 1)],
                '2': ['2', Vue.$trans(`{0}个月`, 2)],
                '3': ['3', Vue.$trans(`{0}个月`, 3)],
                '4': ['4', Vue.$trans(`{0}个月`, 4)],
                '5': ['5', Vue.$trans(`{0}个月`, 5)],
                '6': ['6', Vue.$trans(`{0}个月`, 6)],
                '7': ['7', Vue.$trans(`{0}个月`, 7)],
                '8': ['8', Vue.$trans(`{0}个月`, 8)],
                '9': ['9', Vue.$trans(`{0}个月`, 9)],
                '10': ['10', Vue.$trans(`{0}个月`, 10)],
                '11': ['11', Vue.$trans(`{0}个月`, 11)],
                '12': Vue.$trans(`{0}年`, 1),
                '13': Vue.$trans(`{0}年`, 2),
                '14': Vue.$trans(`{0}年`, 3),
            },
            desc:'',
            // pageLanguage:'',
            startTempData: {},
            eipAllowAttachFlag: false,
            sourcePage: '',
            discountList: ['', '', '', '', '', '', '', '', '', '', '', '', '', ''],
            pageLanguage:'',
            eipQuotaData: {},
            allowGoDown:true,
            isBuyHighDefense:true,
            instanceName:'',
            highDefenseBillType:'',
            highDefenseBillTypeList:[],
            newHighDefenseBillTypeList:[],
            highDefenseLineList:[],
            newHighDefenseLineList:[],
            highDefenseLineId:'',
            protecteList:[],
            newProtecteList:[],
            protecteNum:'',
            ddosMaxBandMap: new Map(),
            maxBand:'',
            maxBandConfig:{},
            ddosBandWidthMap: new Map(),
            bandWidthConfig:{},
            highDefenseBandWidth:'',
            minBwRate:null,
            bdMap:new Map(),
            highDefenseInstanceList:[],
            keadId:'',
            keadObj:{},
            keadDiscount:'',
            ddosPackageMap: new Map(),
            isShowHighDefense:false,
            errorText:false,
            showHighDefense:false,
            supportKead:false
        }
    },
    props: {
        hasBwsSelect: {
            type: Boolean,
            default: true
        },
        cantAddNum: {
            type: Boolean,
            default: false
        },
        buyNum: {
            type: Number,
            default: 1
        },
        regionKey: {
            type: String,
            default: ''
        },
        onTrail: {
            type: Boolean,
            default: false
        },
        DbillType: {
            default: ''
        },
        DstartTempData: {
            type: Object,
            default: () => {}
        },
        DtheSameConfigData: {
            type: Object,
            default: () => {}
        },
        DsourcePage: {
            type: String,
            default: ''
        },
        // 只展示通用配置(所有需要指定用户查询的配置都不展示，主要用户价格计算器等项目)
        onlyCommonConfig: {
            type: Boolean,
            default: false,
            required: false
        },
        azCode: {
            type: String,
            default: 'cn-qingyangtest-1a'
        },
        azCodeList:{
            type: Array,
            default: () => [],
            required: false
        },
        hasAz: {
            type: Boolean,
            default: false
        },
        azName: {
            type: String,
            default: () => '可用区A'
        },
        kecCount: {
            type: Number,
            default: 20
        },
        kecType: {
            type: Number,
            default: 41,
        },
        step3Data: {
            type: Object,
            default: () => {}
        }
    },
    components: {
        pButton, ButtonGroup,
        pRadio,
        pSelect, Option,
        Slider, TimeSilder,
        Spinner,
        Tooltip,
        pForm, FormItem, pInput,
        TimeSildertext,
        KsSlider,
        KsSpinner,
        Card,
    },
    created() {
        this.SKIP = _.get(window, 'KSC_SECNET_CONSOLE.BASE_HOST', 'console.ksyun.com');
        // 获取页面当前语言
        this.pageLanguage = window.KSC_SECNET_CONSOLE.LANG || 'zh';
        //只有自定义购买云服务器支持高防包
        this.showHighDefense = this.$route.name === 'CreateView' ? true : false
    },
    computed: {
        // // 调试用
        // priceSet() {
        //     return priceDataTest
        // },
        ...mapState({
            priceSet: state => state.__pbc__.common.priceSet,
            LineSet: state => state.__pbc__.common.LineSet,
            bwsList: state => state.__pbc__.common.BwsSet,
            billTypeMap: state => state.__pbc__.common.billTypeMap,
            ProjectIds:(state) => {
                return _.map(state.__pbc__.common.projList,item => {
                    return item.ProjectId
                })
            },
        }),
        isDpu(){
            return this.kecType === 713 || this.kecType === 714;
        },
        BillTypes(){
            let list = []
            if(this.isBuyHighDefense) {
                if(this.highDefenseBillType == 1){
                    list = [1,86]
                } else if(this.highDefenseBillType == 2017){
                    // 试用
                    list = [5]
                } else {
                    list = [this.highDefenseBillType]
                }
            } else {
                list = [this.keadObj.BillType]
            }
            return list
        },
        res() {
            return {
                isBuyEip: this.isBuyEip === 'buyNewIP' ? true : false,
                isJoinBws: this.isJoinBws,
                onTrail: this.onTrail,
                onTrailDay: this.onTrailDay,
                eipData: {
                    billType: this.onTrail ? 5 : this.billType,
                    lineType: this.lineId,
                    lineTypeObj: this.eipLineTypeObj,
                    bandwidth: this.bandwidth,
                    time: this.time,
                    durationUnit: this.billType == 1 ? '月' : '日',
                    buyNum: this.buyNum,
                    provider: this.provider
                },
                bwsData: {
                    billType: this.bwsBillType,
                    bwslineName: this.bwslineName,
                    lineType: this.bwsLineId,
                    bws: this.bws,
                    bandwidth: this.bwsBandwidth,
                    time: this.time,
                    buyNum: this.buyNum,
                    provider: this.provider
                },
                update:false,
                bindHighDefense:this.isBuyEip === 'bindHighDefense' ? true : false,
                isBuyHighDefense: this.isBuyHighDefense,
                highDefenseBillType:this.highDefenseBillType,
                highdefenseData:{
                    productWhat:this.isBuyHighDefense && this.highDefenseBillType === 2017 ? 2 : 1,   //非试用都传1,因为高防在主机这边暂时不支持试用，所以写死传1
                    productType:379,
                    link:this.isBuyHighDefense ? this.highDefenseLineId : this.keadObj.LinkType,
                    keadName:this.isBuyHighDefense ? (this.instanceName ? this.instanceName : 'ksc_kead') : this.keadObj.KeadName,
                    keadIpVersion:'IPV4',
                    productUse:this.isBuyHighDefense ? 1 : 3,  //1是新建 3是更配

                    keadDDos:this.isBuyHighDefense ? this.protecteNum : this.keadObj.Band,
                    keadBandWidth:this.isBuyHighDefense ? this.highDefenseBandWidth : this.keadObj.IdcBand,
                    keadIpNumber:this.buyNum,
                    keadMaxBandWidth:this.isBuyHighDefense ? this.maxBand : this.keadObj.MaxBand,
                    serviceTime:1,
                    isp:'kead',
                    projectId:0, // 所属项目，但是这一步没有所属项目的选项，所以暂时传0
                    instanceType: this.isBuyHighDefense ? this.ddosPackageMap.get(this.protecteNum) : this.keadObj.ServiceId,
                    instanceId:this.isBuyHighDefense ? '' : this.keadObj.KeadId,
                    bwsId: this.isBuyHighDefense ? '' : this.keadObj.BwsId,
                    originalKeadIpNumber:this.isBuyHighDefense ? 0 : this.keadObj.IpCount,
                    purchaseTime:this.isBuyHighDefense ? ( this.highDefenseBillType === 2017 ? this.onTrailDay : this.time ): 1,
                    duration:this.isBuyHighDefense ? ( this.highDefenseBillType === 2017 ? this.onTrailDay : this.time ) : 1,
                    billTypes:this.BillTypes,

                },
                // ...this.step3Data
            };
        },
        provider() {
            if (this.isJoinBws) {
                return this.LineNameMapForEip(this.bwslineName);
            } else {
                return this.LineNameMapForEip(_.get(this.eipLineTypeObj, 'LineName'), _.get(this.eipLineTypeObj, 'Isp'));
            }
        },
        bwslineName() {
            return this._getBwsLineName();
        },
        eipLineTypeObj() {
            var res = _.find(this.eipOrderBillLineSetFilter, (item) => {return item.LineId == this.lineId}) || {};
            if (!_.isEmpty(res)) {
                if (res.LineType == "Private") {
                    this.bandwidth = 1000;
                }
            }
            return res;
        },
        eipOrderBillLineSetFilter() {
            var eipOrderBill = this.billType + '';
            var list = this.LineSet;
            // if (_.indexOf(['1'], eipOrderBill) != -1 || this.onTrail) { //包年包月，按日计费(试用)，不支持移动，电信，联通链路类型
            return _.filter(list, (item) => {
                // return _.indexOf(['联通', '电信', '移动', 'AuditBGP'], item.LineName) == -1 && item.LineType !== 'Private';;
                if (_.indexOf(this.regionKey.split('-'), 'qingdao') != -1) { //青岛机房 放开EIP静态链路的售卖
                    return item.LineType !== 'Private';
                } else if(this.regionKey === 'cn-northwest-1' || this.regionKey === 'cn-northwest-2') {
                    return _.indexOf(['联通', '电信', 'AuditBGP'], item.LineName) == -1 && item.LineType !== 'Private';
                } else if(this.regionKey === 'cn-northwest-3') {
                    return _.indexOf(['联通', '移动', 'AuditBGP'], item.LineName) == -1 && item.LineType !== 'Private';
                } else {
                    return _.indexOf(['联通', '电信', '移动', 'AuditBGP'], item.LineName) == -1 && item.LineType !== 'Private';
                }
            })
            // } //所有计费方式都屏蔽
            return list;
        },
        time:{
            get(){
                return this.chooseTimeValue > 11 ? (this.chooseTimeValue - 11)*12 : this.chooseTimeValue
            },
            set(){}

        },
        isShowBuyTime(){
            if(this.isBuyEip === "buyNewIP"){
                return !this.onTrail && !this.isJoinBws && this.billType == 1
            } else if(this.isBuyEip === 'bindHighDefense'){
                return this.highDefenseBillType == 1 && this.isBuyHighDefense
            }
            return false
        },
        billType95() {
            return this.highDefenseBillType && this.highDefenseBillType === 807 ? true : false
        },
        getMinBwRate() {
            return this.minBwRate ? this.minBwRate :  this.bdMap.get(this.protecteNum)
        },
        floorsBandWidth() {
            return ( this.getMinBwRate *  (this.highDefenseBandWidth / 100)  ).toFixed(2)
        },
        isVPCTrust(){
            return this.step3Data?.vpcObj?.ProductTag === 'trust'
        }
    },
    watch: {
        isVPCTrust(val){
            if(val){
                this.isBuyEip = 'buyLater'
            }
            
        },
        highDefenseBillType(val){
            console.log('highDefenseBillType:::',val)
            this.exportData()
        },
        highDefenseLineId(){
            this.exportData()
        },
        instanceName(){
            // this.exportData()
        },
        keadId(val){
            this.keadObj = (_.filter(this.highDefenseInstanceList,item => item.KeadId === val) || [])[0] || {}
            // this.exportData()
        },
        keadObj(val){
            console.log('keadObj:::',val)
            this.exportData()

        },
        protecteNum(){
            // this.maxBandConfig = this.ddosMaxBandMap.get(this.protecteNum)
            this.setHighDefenseInitData()
            this.exportData()
        },
        maxBand(){
            this.exportData()
        },
        highDefenseBandWidth(){
            this.exportData()
        },
        isJoinBws:{
            immediate:true,
            handler(val){
                this.initData()
            }

        },
        isBuyHighDefense(val){
            if(val){
                this.keadId = ''
            }
            this.initData()
            // this.exportData()
        },
        buyNum() {
            this.eipCount = this.buyNum;
        },
        eipCount() {
            if(this.isBuyEip === 'buyNewIP'){
                this.getCheckEipQuota()
            }
            this.exportData();
        },
        lineId() {
            // console.log(this.lineType,1111);
            this.initLineSetData();
        },
        // step3Data:_.debounce(function(val){
        //     // this.res.update = true
        //     this.$emit('changeStep3Data', val)
        // },120)
    },

    methods: {
        // setCommonDiscount() {
        //     let defaultDiscountlist = [9, 9, 8, 8, 8, 7.5, 7.5, 7.5, 7.5, 7.5, 7.5, 7, 5.8, 4.3]; //数据来源于组件 KsTimerSlidertext 的默认折扣
        //     let _disCountList = [];
        //     if (this.pageLanguage == 'zh') {
        //         _disCountList = defaultDiscountlist;
        //     } else {
        //         // 如果是英文版 则需要把折扣转换为英文的表述
        //         _.forEach(defaultDiscountlist, (item) => {
        //             _disCountList.push(100 - item * 10);
        //         });
        //     }

        //     this.discountList = _disCountList;
        // },
        tryDoChunk(val,newVal){
            if(Array.isArray(val)){
                val.length && (this[newVal] = _.chunk(val, 6));
            } else {
                this[val].length && (this[newVal] = _.chunk(this[val], 6));
            }

        },
        getDurationUnit(billType) {
            if (billType == 1) {
                return this.$trans(`月`)
            }
            if (billType == 5) {
                return this.$trans(`天`);
            }
            if (billType == 84 || billType == 87 || billType == 810) {
                return this.$trans(`小时`)
            }
            return ''
        },
        setValue(key, value) {
            console.log(key, value, 123)
            this.$set(this, key, value);
        },
        trailDayChange() {
            if(this.isBuyEip === 'buyNewIP'){
                let orderType = this.onTrailDay;
                let a = orderType.trim(),
                    reg = /^\d+$/, me = this;
                if(!reg.test(a)) {
                    me.onTrailDay = 1;
                } else {
                    me.onTrailDay = Math.min(14, Math.max(1, orderType));
                }
            }
        },
        setInitData(params) {
            _.map(_.keys(params), (key) => {
                if (key != 'isShow') {
                    this[key] = params[key];
                }
            });
            if (this.hasPrecondition) {
                return this.preconditionFunc(params.isShow);
            } else {
                this.isShow = params.isShow || false;
            }
        },

        setItem(key, val) {
            this[key] = val;
        },

        LineNameMapForEip: function(key, name) {
            var map = {
                '移动': 'YiDong',
                '电信': 'DianXin',
                '联通': 'LianTong',
                '优化BGP': 'zenlayer-guoneiyouhua',
                'vBGP': 'vBGP',
            };
            return map[key] || name || 'BGP';
        },

        preconditionFunc(isShow) {
            var promise = $.Deferred();
            // this.getIpv6SupportProductType(), this._fetchVpcData()
            promise = $.when(this._fetchEipData(), this._fetchLineSet(), this._fetchBwsSet(), this.getKeadValidWhitelist());
            // , this.$refs.createSubnet.ValidateIpv6Support(), this.$refs.createSubnet._fetchVpcData()
            return promise.then((res) => {
                this.$nextTick(() => {
                    // bwsListWithoutStaticLine
                   this.getBwsListWithoutStaticLine()
                    // console.log(this.bwsList);
                    // console.log(this.LineSet);
                });
            }, (e) => {
                Message.error(e.msg || e);
            }).then(() => {
                this.isShow = isShow;
                // if (this.DsourcePage == 'createTemplate' || this.DsourcePage == 'modifyTemplate') {
                //     this.showBwsSelect = false;
                //     this.showBuyEipNum = false;
                // }
                if ((this.DsourcePage == 'modifyTemplate' || this.DsourcePage == 'buyTemplate') && Object.keys(this.DstartTempData).length) {
                    // 重置EIP数据
                    let listData = this.eipOrderBillLineSetFilter;
                    if (this.DstartTempData.lineInfo) {
                        this.isBuyEip = 'buyNewIP';
                        const BandWidthShareId = _.get(this.DstartTempData, 'BwsId', '')
                        if (BandWidthShareId) {
                            this.isJoinBws = true
                            this.bws = _.find(this.bwsListWithoutStaticLine, (item) => {
                                return item.BandWidthShareId == BandWidthShareId;
                            }).BandWidthShareId || '';
                            this.bwsBillType = _.find(this.billTypeList, (item) => {
                                return item.billTypeId == _.get(this.DstartTempData, 'OrderInfo.AddressBillType');
                            }).billTypeId || '';
                            if (this.bwsBillType == '') {
                                Message.error(this.$trans(`所选EIP计费方式不存在，请重新选择`));
                                this.bwsBillType = _.get(this.billTypeList, '[0].billTypeId', '');
                            }
                        } else {
                            this.isJoinBws = false
                            this.billType = _.find(this.billTypeList, (item) => {
                                return item.billTypeId == _.get(this.DstartTempData, 'OrderInfo.AddressBillType');
                            }).billTypeId || '';
                            if (this.billType == '') {
                                Message.error(this.$trans(`所选EIP计费方式不存在，请重新选择`));
                                this.billType = _.get(this.billTypeList, '[0].billTypeId', '');
                            }
                        }
                        this.bandwidth = _.get(this.DstartTempData, 'AddressBandWidth', '');
                        this.lineId = _.find(listData, (item) => {
                            return item.LineId == _.get(this.DstartTempData, 'lineInfo.LineId');
                        }).LineId || '';
                        if (this.lineId == '') {
                            Message.error(this.$trans(`所选链路类型不存在，请重新选择`));
                            this.lineId = _.get(listData, '[0].LineId', '');
                        }
                        // this.time = _.toString(_.get(this.DstartTempData, 'AddressPurchaseTime', ''));
                        this.chooseTimeValue = _.toNumber(_.get(this.DstartTempData, 'AddressPurchaseTime', ''));
                    } else {
                        this.isBuyEip = 'buyLater';
                    }
                }
                if (this.DsourcePage == 'createTheSameConfig' && Object.keys(this.DtheSameConfigData).length) {
                    // 重置EIP数据
                    let listData = this.eipOrderBillLineSetFilter;
                    if (this.DtheSameConfigData.eipInfo && Object.keys(this.DtheSameConfigData.eipInfo).length) {
                        this.isBuyEip = 'buyNewIP';
                        const BandWidthShareId = _.get(this.DtheSameConfigData, 'eipInfo.BandWidthShareId');
                        if(BandWidthShareId){
                            this.isJoinBws = true
                            this.bws = _.find(this.bwsListWithoutStaticLine, (item) => {
                                return item.BandWidthShareId == BandWidthShareId;
                            }).BandWidthShareId || '';

                            this.bwsBillType = _.find(this.billTypeList, (item) => {
                                return item.billTypeId == _.get(this.DtheSameConfigData, 'eipInfo.OrderInfo.billType');
                            }).billTypeId || '';
                            if (this.bwsBillType == '') {
                                Message.error(this.$trans(`所选EIP计费方式不存在，请重新选择`));
                                this.bwsBillType = _.get(this.billTypeList, '[0].billTypeId', '');
                            }
                        } else {
                            this.isJoinBws = false
                            this.billType = _.find(this.billTypeList, (item) => {
                                return item.billTypeId == _.get(this.DtheSameConfigData, 'eipInfo.OrderInfo.billType');
                            }).billTypeId || '';
                            if (this.billType == '') {
                                Message.error(this.$trans(`所选EIP计费方式不存在，请重新选择`));
                                this.billType = _.get(this.billTypeList, '[0].billTypeId', '');
                            }
                            this.bandwidth = _.get(this.DtheSameConfigData, 'eipInfo.BandWidth', '');

                            this.lineId = _.find(listData, (item) => {
                                return item.LineId == _.get(this.DtheSameConfigData, 'eipInfo.LineInfo.LineId');
                            }).LineId || '';
                            if (this.lineId == '') {
                                Message.error(this.$trans(`所选链路类型不存在，请重新选择`));
                                this.lineId = _.get(listData, '[0].LineId', '');
                            }
                            // this.time = _.toString(_.get(this.DtheSameConfigData, 'AddressPurchaseTime', ''));
                        }

                    } else {
                        this.isBuyEip = 'buyLater';
                    }
                }
                this._bindWatch();
                this.exportData();
            });
        },
        getBwsListWithoutStaticLine(){
            let validLineIds = [];
            let notSupportLineList = ['联通', '移动', '电信']
            if(this.regionKey === 'cn-northwest-1' || this.regionKey === 'cn-northwest-2') {
                notSupportLineList = ['联通', '电信']
            } else if(this.regionKey === 'cn-northwest-3'){
                notSupportLineList = ['联通', '移动']
            }
            _.forEach(this.LineSet, line => {
                if (!_.includes(notSupportLineList, line.LineName)) {
                    validLineIds.push(line.LineId);
                }
            });
            this.bwsListWithoutStaticLine = _.filter(this.bwsList, bws => {
                return _.includes(validLineIds, bws.LineId);
            });
        },
        // 增强95付费获取保底带宽值
        getDescribeKeadMinRate(){
            this.$store.dispatch(step2Const.DescribeKeadMinRate,{
                params:{
                    Region:this.regionKey,
                }
            }).then(res => {
                this.minBwRate = res.MinBwRate
            })
        },
        // 获取当前账号下所有所属项目
        _getProList() {
            return this.$store.dispatch(pcommon.projList, {
                params: {
                    Region: 'cn-qingyangtest-1',
                    type: 'DescribeInstances'
                }
            })
        },
        // 获取已有高防包列表
        getDescribeKead(){
            this.$store.dispatch(step2Const.DescribeKead,{
                params:{
                    Region:this.regionKey
                },
                data:{
                    projectIds:this.ProjectIds
                }
            }).then(res => {
                // console.log('res:::',res)
                if(res.KeadSet){
                    this.highDefenseInstanceList = _.filter(res.KeadSet,item => {
                        if(this.onTrail){
                            return item.LinkType === "BGP-01" && item.ProductWhat === 4
                        } else {
                            return item.LinkType === "BGP-01" && item.ProductWhat !== 4
                        }

                    }) || []
                    this.keadId = this.highDefenseInstanceList.length ?  this.highDefenseInstanceList[0].KeadId : ''
                }


            })
        },
        initData() {
            if (!this.regionKey) {
                return;
            }

            var isJoinBws = this.isJoinBws;
            // 是否支持高防弹性包
            var product = this.getProduct(208, 379)
            if(Object.keys(product).length){
                // 可用区
                const regionList = product.regionList || []
                if(!regionList.length){
                    this.isShowHighDefense = false
                    return
                }
                const hasRes = _.filter(regionList,item => item.regionCode === this.regionKey)
                this.isShowHighDefense = hasRes.length ? true : false
            }
            //重置弹性IP选项
            if(!this.isShowHighDefense && this.isBuyEip === 'bindHighDefense'){
                this.isBuyEip = 'buyLater'
            }
            if(this.isBuyEip === 'bindHighDefense'){
                if(this.isBuyHighDefense){
                    this.getDescribeKeadMinRate()
                    return this.iniHighDefensePackage(product)
                } else {
                    this._getProList().then(() => {
                        this.getDescribeKead()
                    })

                }
            } else {
                if (isJoinBws) {
                    return this.initBwsPackage();
                } else {
                    return this.initEipPackage();
                }
            }

        },

        resetData() {
            this.billTypeList = [];
            this.bwsBillTypeList = [];
            this.billType = '';
        },
        getProduct(productGrpId, productId){
            var productGrp = _.filter(_.get(this.priceSet, 'data'), (item) => {
                return item.productGroupId == productGrpId; //产品线
            });
            var product = _.filter(_.get(productGrp, '[0].productTypeList', []), (item) => {
                return item.productTypeId == productId;　//类型
            })[0] || {};
            return product
        },
        _initPackage(productGrpId, productId, propCode) {

            if (!this.regionKey) {
                return;
            }
            if(_.isEmpty(this.priceSet)) {
                return;
            }
            var product = this.getProduct(productGrpId, productId)

            // 格式化所有配置
            let formatted = {};
            _.forEach(product.packageList, packageInfo => {
                _.forEach(packageInfo.refRegionList, region => {
                    if (!formatted[region.regionCode]) {
                        formatted[region.regionCode] = {
                            region,
                            data: {}
                        };
                    }
                    _.forEach(packageInfo.refBillTypeList, billType => {
                        if (!formatted[region.regionCode].data[billType.billTypeId]) {
                            formatted[region.regionCode].data[billType.billTypeId] = {
                                billType,
                                maxBandwidth: 0,
                                data: []
                            };
                        }
                        formatted[region.regionCode].data[billType.billTypeId].data.push(packageInfo);
                        let netProp = _.find(packageInfo.packageInfo, ['propCode', 'net']);
                        let max = _.get(netProp, 'propValue[0].max', 0);
                        if (formatted[region.regionCode].data[billType.billTypeId].maxBandwidth < max) {
                            formatted[region.regionCode].data[billType.billTypeId].maxBandwidth = max;
                        }
                    });
                });
            });
            this.formattedPriceData[productId] = formatted;
            // 获取当前region的全部计费方式，以及对应的配置
            let hasConfig = formatted[this.regionKey];


            // var hasConfig = _.find(product.regionList, (item) => {
            //     return item.regionCode == this.regionKey;
            // });
            if (_.isEmpty(hasConfig)) {
                this.resetData();
                if (productId == 50) {
                    this.noConfigBws = true;
                }
                if (!this.isJoinBws && productId == 50) {
                    return ;
                }
                return Message.error(this.$trans(`未配置，请联系客服400-028-9900`));
            }

            // todo: 试用也要根据package的配置看用哪个
            if (productId != 50) {

                let billTypeList = [];
                _.forEach(hasConfig.data, (data, billType) => {
                    billTypeList.push(data.billType);
                });

                if (this.onTrail) {
                    /**
                     * 	试用逻辑
                     a.	产品：EIP、BWS、NAT、PEERING、SLB、VPN
                     b.	策略：
                     i.	有按日月结套餐的使用按日月结套餐的权限校验试用
                     ii.	没有按日月结，有包年包月的，使用包年包月的套餐权限校验试用
                     iii.	没有按日月结和包年包月的取第一个套餐权限校验试用
                     iv.	没有任何计费方式的，不允许试用，不展示试用计费方式
                     */
                    // this.billTypeList = [{billTypeId: 5, billTypeName: this.$trans(`按量付费（按日月结）`) + '('+ this.$trans(`试用`) +')'}]

                    if (_.find(billTypeList, ['billTypeId', 5])) {
                        this.billTypeList = [{billTypeId: 5, billTypeName: this.$trans(`试用`)}]; // + '('+ this.$trans(`试用`) +')'}]
                    } else if (_.find(billTypeList, ['billTypeId', 1])) {
                        this.billTypeList = [{billTypeId: 1, billTypeName: this.$trans(`试用`)}];// + '('+ this.$trans(`试用`) +')'}]
                    } else {
                        // 没有按日月结和包年包月，从可用套餐里取带宽值最大的
                        let max = null
                        _.forEach(billTypeList, billType => {
                            let billTypeData = hasConfig.data[billType.billTypeId];
                            if (!max || max.max < billTypeData.maxBandwidth) {
                                max = {
                                    billTypeId: billType.billTypeId,
                                    max: billTypeData.maxBandwidth
                                };
                            }
                        });
                        // this.billTypeList = [{billTypeId: _.first(billTypeList).billTypeId, billTypeName: this.$trans(`试用`)}] // + '('+ this.$trans(`试用`) +')'}]
                        this.billTypeList = [{billTypeId: max.billTypeId || _.first(billTypeList).billTypeId, billTypeName: this.$trans(`试用`)}] // + '('+ this.$trans(`试用`) +')'}]
                    }
                } else {
                    this.billTypeList = billTypeList || [];
                }
                this.tryDoChunk('billTypeList','newBillTypeList')
                this.setBillType();

            } else {
                // if(this.DsourcePage == 'createTheSameConfig'){
                //     let billTypeList = [];
                //     _.forEach(hasConfig.data, (data, billType) => {
                //         billTypeList.push(data.billType);
                //     });
                //     console.log('this.billTypeList323232',billTypeList)
                //     this.billTypeList = billTypeList || [];
                //     console.log('this.billTypeListTest::',this.billTypeList)
                // }

                this.bwsSetBillType();
            }

            // // 获取packageList
            // let packageList = _.get(product, 'packageList[0].packageInfo');
            // var propertyNet = _.find(packageList, (item, key) => {
            //     return item.propCode == propCode;
            // });

            // if (!_.isEmpty(propertyNet)) {
            //     var netObj = _.get(propertyNet, 'propValue[0]', {});
            //     this.maxBandwidth = netObj.max;
            //     this.minBandwidth = netObj.min == 0 ? 1 : netObj.min;
            //     this.step = netObj.step;
            // }
            return true;
        },

        initEipPackage() {
            // this._initPackage(113, 50, 'bandwidth');
            var res = this._initPackage(102, 9, 'net');
            return res;
        },
        initBwsPackage() {
            var res = this._initPackage(113, 50, 'bandwidth');
            return res;
        },
        iniHighDefensePackage(product){
            // var res = this._initPackage(208, 379, 'bandwidth');
            // return res;

            //计费方式
            if(this.onTrail){
                this.highDefenseBillTypeList = [{billTypeId: 2017, billTypeName: this.$trans(`试用`)}]
            } else {
                const billTypeList= product.billTypeList || []
                this.highDefenseBillTypeList = _.filter(billTypeList,item => item.billTypeId !== 86)
            }

            // 线路类型 过滤BGP-02类型的线路
            const linkType = _.find(product.propertyList, {propCode:'Link'}) || {}
            this.highDefenseLineList = _.filter(linkType.propValue, item => item.value !== 'BGP-02')
            if(!this.highDefenseLineList){
                return
            }
            // 防护能力
            this.protecteList = Array.from(new Set(_.map(product.packageList,item => {
                const linkType = _.find(item.packageInfo,{propCode : 'Link'}) || {}
                if(linkType.propValue && Array.isArray(linkType.propValue)){
                    if(_.every(linkType.propValue,item => item.value === 'BGP-02')){
                        return undefined
                    }
                }
                const pkg = _.find(item.packageInfo,{propCode : 'KEAD_DDoS'}) || {}
                const value = pkg.propValueType !== 2 ? undefined : ((pkg.propValue || [])[0] || {}).min
                this.setOtherData(value,item)
                return value
            }))).filter(item => typeof item === 'number').sort((a,b) => a - b)


            this.tryDoChunk('highDefenseBillTypeList','newHighDefenseBillTypeList')
            this.tryDoChunk('highDefenseLineList','newHighDefenseLineList')
            this.tryDoChunk('protecteList','newProtecteList')
            this.highDefenseBillType = this.highDefenseBillTypeList[0].billTypeId
            this.highDefenseLineId = this.highDefenseLineList[0].value
            this.protecteNum = this.protecteList[0]
            this.setHighDefenseInitData()
        },
        setOtherData(value,item){
            if(!value){
                return
            }
            const bandWidth = _.find(item.packageInfo, { propCode: "KEAD_BW" })
            const maxBand = _.find(item.packageInfo, { propCode: "KEAD_LIMIT" })
            const bd = _.find(item.packageInfo, { propCode: "KEAD_BD" })
            // 弹性上线
            if(maxBand){
                let propValue = _.get(maxBand, "propValue", [])
                const mergeValue  = propValue.length > 1 ? this.mergePropValueType4(propValue) : propValue[0]
                if (this.ddosMaxBandMap.has(value)) {
                    const oldValue = this.ddosMaxBandMap.get(value)
                    if(oldValue && oldValue.max > mergeValue.max){
                        const config = mergeValue.max > oldValue.max ? mergeValue : oldValue
                        this.ddosMaxBandMap.set(value, config)
                    }
                } else {
                    this.ddosMaxBandMap.set(value, mergeValue)
                }

            }
            // 带宽值
            if(bandWidth){
                const bindValue = _.get(bandWidth, "propValue", [])[0]
                if (this.ddosBandWidthMap.has(value)) {
                    const oldValue = this.ddosBandWidthMap.get(value)
                    if (oldValue && bindValue.max > oldValue.max) {
                        const config = bindValue.max > oldValue.max ? bindValue : oldValue
                        this.ddosPackageMap.set(value, item.packageCode)
                        this.ddosBandWidthMap.set(value, config)
                    }
                } else {
                    this.ddosPackageMap.set(value, item.packageCode)
                    this.ddosBandWidthMap.set(value, bindValue)
                }

            }
            if(bd){
                let propValue = _.get(bd, "propValue", []);
                let min = Math.min(_.map(propValue,item => item.min))
                const oldValue = this.bdMap.get(value)
                let _min = min;
                if (oldValue){
                    _min = min < oldValue ? min : oldValue
                }
                this.bdMap.set(value, _min)
            }
        },
        setHighDefenseInitData(){
            this.maxBandConfig = this.ddosMaxBandMap.get(this.protecteNum)
            this.maxBand = this.maxBandConfig.min
            this.bandWidthConfig = this.ddosBandWidthMap.get(this.protecteNum)
            this.highDefenseBandWidth = this.bandWidthConfig.min
        },
        mergePropValueType4(values){
            let step = {}
            values.forEach(v =>{step[v.max] = v.step })
            return values.reduce((p, v) => ({
                min: p.min < v.min ? p.min : v.min ,
                max: p.max > v.max ? p.max : v.max,
                step: step  ,
                values
            }))
        },
        _bindWatch() {
            this.$watch('onTrailDay', this.exportData);
            this.$watch('onTrail', this.setType);
            this.$watch('isBuyEip', this.changeBuyEip);
            this.$watch('billType', this.initLineSetData);
            this.$watch('lineId', this.exportData);
            this.$watch('bandwidth', this.exportData);
            this.$watch('time', this.exportData);
            this.$watch('buyNum', this.exportData);
            this.$watch('bwslineName', this.exportData);
            // this.$watch('isJoinBws', (val)=>{
            //     console.log('isJoinBws:::',val)
            //     this.initData()
            // });
            this.$watch('regionKey', this.initData);
            this.$watch('bws', this.bwsSetBillType);
            this.$watch('bwsBillType', this.exportData);
        },
        changeBuyEip(val){
            if (val === 'buyNewIP') {
               this.getCheckEipQuota()
            }
            if (val === 'buyNewIP' || val === 'bindHighDefense') {
                this.onTrailDay = 1
                this.chooseTimeValue = 1
            }

            this.initData()
            this.exportData()
        },
        getCheckEipQuota(){
            //EIP数量校验
            this.$store.dispatch(step2Const.CheckEipQuota,{
                params:{
                    Region:this.regionKey,
                    EipCount:this.eipCount,
                    BillType:this.isJoinBws ? this.bwsBillType : this.billType
                }
            }).then(res => {
                //EipAllowAttachFlag 表示是否可以绑定EIP, 为false “购买新的弹性IP” 不可选择
                if (res && res.EipAllowAttachFlag) {
                    this.eipAllowAttachFlag = true;
                } else {
                    this.eipAllowAttachFlag = false;
                }

                //没有选择购买新的EIP，不需要报EIP相关错误
                if (this.isBuyEip === 'buyNewIP') {
                    this.eipQuotaData = res;
                    this._checkEipQuota();
                }

            }).catch(e => {
                console.log(e)
            })
        },
        _checkEipQuota() {
            let data = this.eipQuotaData;
            if (_.isEmpty(data)) {
                return;
            }
            if (data.quota_eip_limit && data.quota_eip_dailyorder) {
                this.allowGoDown = true
            } else {
                this.allowGoDown = false
                if (!data.quota_eip_limit && !data.quota_eip_dailyorder) {
                    Message.error(this.$trans(`弹性IP数量超过您在该数据中心可购买限额和今日可购买限额，若需调整限额请提工单`)); //弹性IP数量超过您在该数据中心可购买限额和今日可购买限额，若需调整限额请提工单
                    return
                }
                if (!data.quota_eip_limit) {
                    Message.error(this.$trans(`弹性IP数量超过您在该数据中心可购买限额，若需调整限额请提工单`)); //弹性IP数量超过您在该数据中心可购买限额，若需调整限额请提工单
                    return
                }
                if (!data.quota_eip_dailyorder) {
                    Message.error(this.$trans(`弹性IP数量超过今日可购买限额，若需调整限额请提工单`)); //弹性IP数量超过今日可购买限额，若需调整限额请提工单
                    return
                }

                if (this.isBuyEip === 'buyNewIP') {
                    clearInterval(this.$parent.goTabTimer);
                    this.$parent.goTabTimer = null;
                    return
                }
            }
            return true
        },
        setType() {
            if (this.onTrail) {
                if (this.isJoinBws) {
                    this.isJoinBws = false;
                }
            }
        },
        bwsSetBillType() {
            let inIt = false;
            this.bwsBillTypeList = _.filter(this.billTypeList, item => {
                if (this.bwsBillType == item.billTypeId) {
                    inIt = true;
                }
                return item.billTypeId == 3 || item.billTypeId == 5 ||  item.billTypeId == 83 || item.billTypeId == 84 || item.billTypeId == 86 || item.billTypeId == 704;
            }) || [];

            if (!inIt) {
                this.bwsBillType = this.bwsBillTypeList[0] ? this.bwsBillTypeList[0].billTypeId : '';
            }
            console.log(this.bwsBillTypeList)
            this.tryDoChunk('bwsBillTypeList','newBwsBillTypeList')
            this.exportData();
        },
        setBillType() {
            var first = _.get(this.billTypeList, '[0].billTypeId', '');
            if (this.DbillType) {
                if (!_.find(this.billTypeList, (item) => {return item.billTypeId == this.DbillType})) {
                    this.billType = first;
                } else {
                    this.billType = this.DbillType;
                }
            } else {
                this.billType = first;
            }
        },

        async doCalcPrice(params) {
            let me = this;
            // console.log(params, 'params')
            var requestParams = {};
            if (!params) {
                return;
            }
            if (params.isJoinBws) {
                //加入共享带宽价格字段单独处理: 按月峰值付费(月结)、 按月增强95峰值付费(月结)、按月用量付费(月结)、地域共享带宽、按日用量实时付费
                if (_.includes([3, 807, 704, 83, 86], params.bwsData.billType)) {
                    params.eipPrice = me.$trans(`IP占用费以账单的消耗为准`); //IP占用费以账单的消耗为准
                    params.isShowEipText = true;
                } else {
                    params.eipPrice = '';
                    params.isShowEipText = false;
                }

                if (params.bwsData) {
                    requestParams = {
                        billType: params.bwsData.billType,
                        count: me.eipCount,//me.count,//me.kvmData.count, //数量必须和云服务器保持一致
                        bwsId: params.bwsData.bws,
                        lineId: params.bwsData.lineType,
                        duration: params.onTrail? params.onTrailDay : params.eipData.time,
                        durationUnit: '日',
                        provider: params.bwsData.provider
                    }
                    // if(!param.billType || !param.count ||!param.duration || !param.net || !param.lineId ||!param.provider ) return;
                    if(!requestParams.billType || !requestParams.count ||!requestParams.duration || !requestParams.lineId ||!requestParams.provider ) return;
                    // return this.$store.dispatch(pcommon.CalcEipPrice, {
                    //     params: {
                    //         Region: params.regionKey
                    //     },
                    //     data: requestParams,
                    //     options: {
                    //         showLoading: false,
                    //         isJSON: true
                    //     }
                    // })
                }

            } else {

                if (!params.isBuyEip) {
                    return;
                }

                //不加入共享带宽价格字段单独处理:
                if (_.includes([3, 83], params.eipData.billType)) { //按月峰值付费(月结)、地域共享带宽
                    params.eipPrice = me.$trans(`按实际使用峰值计费`); //按实际使用峰值计费
                    params.isShowEipText = true;
                } else if (_.includes([704, 86], params.eipData.billType)) { //按日用量实时付费、按月用量付费(月结)
                    params.eipPrice = me.$trans(`按实际使用流量计费`); //按实际使用流量计费
                    params.isShowEipText = true;
                } else if (params.eipData.billType == 807) { //按月增强95峰值付费(月结)
                    params.eipPrice = me.$trans(`按实际使用峰值及保底带宽计费`); //按实际使用峰值及保底带宽计费
                    params.isShowEipText = true;
                } else {
                    params.eipPrice = '';
                    params.isShowEipText = false;
                }

                requestParams = {
                    billType: params.eipData.billType,
                    duration: params.onTrail? params.onTrailDay : params.eipData.time,
                    durationUnit: params.eipData.billType == 1 ? '月' : '日',
                    count: me.eipCount, //kvmData.count,
                    net: params.eipData.bandwidth,
                    lineId: params.eipData.lineType,
                    provider: params.eipData.provider
                }
                if(params.onTrail) {
                    requestParams.productWhat = 2;
                    // let eipTryOrderDay = this.eipTryOrderDay + '';
                    // if(!reg.test(eipTryOrderDay.trim())) {
                    //     return;
                    // }
                }

                if(!requestParams.billType || !requestParams.count ||!requestParams.duration || !requestParams.net || !requestParams.lineId ||!requestParams.provider ) return;
            }

            if (params.isShowEipText) {
                return;
            }

            let req = this.$store.dispatch(pcommon.CalcEipPrice, {
                params: {
                    Region: me.regionKey
                },
                data: requestParams,
                options: {
                    showLoading: false,
                    isJSON: true
                }
                // }).then(function() {
                //     me.eipPrice = me.eipPriceSet.price;
            });
            try {
                let data = await req;
                params.eipPrice = _.get(data, 'price');
                //重制eip折扣

                this.setDiscountData(data.eipPriceDetails)

            } catch(e) {
                console.log(e)
            }
        },
        async doKeadCalcPrice(params) {
            // console.log(params, 'params')
            if (!params) {
                return;
            }
            let req = this.$store.dispatch(pcommon.CalculateKeadProduct, {
                params: {
                    Region: this.regionKey
                },
                data: params,
                options: {
                    showLoading: false,
                    isJSON: true
                }
            });
            try {
                let data = await req;
                params.price = data.price
                this.setDiscountData(data.priceDetails['0'])

            } catch(e) {
                console.log(e)
            }
        },

        setDiscountData(price){
            const index = this.time > 11 ? (this.time/12) + 10 : (this.time - 1)
            let discount = ''
                if(this.pageLanguage === 'zh'){
                    discount =price.discount*10
                    if (this.discountList[index] != discount) {
                        this.$set(this.discountList, index, discount)
                    }
                } else {
                    discount = 100 - (price.discount.toFixed(2)*100)
                    if (this.discountList[index] != discount) {
                        this.$set(this.discountList, index, discount)
                    }

                }
        },
        calcuPrice() {
            this.exportData();
        },
        exportData: _.debounce(async function() {
            this.res.update = false
            if (this.onlyCommonConfig) {
                let res = this.res;
                this.$emit('change:param:eip', res);
                await this.doCalcPrice(res);
                this.$emit('input', res)
            } else {
                this.$emit('input', this.res)
            }
        }, 50),

        $checkValid(callback) {
            if(this.isVPCTrust) return callback && callback() || true;
            //加入共享带宽，共享带宽没有数据时
            if(this.isBuyEip === 'buyNewIP' && this.isJoinBws && !this.bwsListWithoutStaticLine.length){
                Message.error(this.$trans(`当前共享带宽为空，请先创建共享带宽`));
                clearInterval(this.$parent.goTabTimer);
                this.$parent.goTabTimer = null;
                return
            }
            //EIP数量校验
            if (this.isBuyEip === 'buyNewIP') {
                if(!this._checkEipQuota()){
                    return 
                }
                // if (!this.allowGoDown) {
                //     clearInterval(this.$parent.goTabTimer);
                //     this.$parent.goTabTimer = null;
                //     return
                // }
            }
            if(this.isBuyEip === 'bindHighDefense' && ((this.isBuyHighDefense && !this.highDefenseLineList) || (!this.isBuyHighDefense && !this.highDefenseInstanceList.length))){
                if(!this.highDefenseLineList){
                    Message.error('没有对应的线路类型');
                } else if(!this.highDefenseInstanceList.length){
                    Message.error('选择高防包实例');
                }

                return
            }
            return this.$refs.inputForm.validate()
            // .then((res) => {
            //     return _.isFunction(callback) && callback(res);
            // });
        },

        _getBwsLineName: function() {
            var bwsObj = (_.find(this.bwsList || [], (item) => {
                return item.BandWidthShareId === (this.bws || '');
            }) || {});

            var bwLineId = bwsObj.LineId;

            var lineName = (_.find(this.eipOrderBillLineSetFilter, function(item) {
                return item.LineId == bwLineId;
            }) || {}).LineName;

            this.bwsBandwidth = bwsObj.BandWidth || "";
            this.bwsLineId = bwLineId;
            return lineName;
        },

        _fetchEipData() {
            return this.$store.dispatch(pcommon.QueryProductGroups, {
                params: {
                    productGroupIdList: '113,102,208',
                    Region: this.regionKey
                }
            }).then((res) => {
                this.initData();
                this.getCheckEipQuota(); //页面进到网络配置就读一下这个接口，用于判断 用户是否有该机房绑定EIP的权限
            }, (e) => {
                Message.error(e.msg || e);
            });
        },

        _fetchLineSet() {
            return  this.$store.dispatch(pcommon.Getlines, {
                params: {
                    Region: this.regionKey
                }
            }).then(() => {
                return this.initLineSetData();
            }, (e) => {
                Message.error(e.msg || e);
            });
        },
        refreshBwsList(){
            this._fetchBwsSet('isRefresh')
        },
        _fetchBwsSet(isRefresh) {
            return  this.$store.dispatch(pcommon.DescribeBandWidthShares, {
                params: {
                    Region: this.regionKey
                }
            }).then(() => {
                if(isRefresh){
                    this.getBwsListWithoutStaticLine()
                }
                this.bws = _.get(this.bwsList, '[0].BandWidthShareId', '');
            }, (e) => {
                Message.error(e.msg || e);
            });
        },
        initLineSetData() {
            if (this.isBuyEip === 'buyNewIP') {
                this.getCheckEipQuota();
            }

            var list = this.eipOrderBillLineSetFilter;
            var first = '';

            var bgpData = _.filter(list, (item) => {
                return item.Isp == 'BGP';
            });

            // 20201231 产品需求：链路类型默认值为: BGP
            if (bgpData && bgpData.length) {
                // first = _.get(bgpData, '[1].LineId', '');
                first = bgpData.length > 1 ? bgpData[1].LineId : bgpData[0].LineId
            } else {
                first = _.get(list, '[0].LineId', '');
            }

            if (!this.lineId) {
                this.lineId = first;
            } else {
                if (!_.find(list, (item) => {return item.LineId == this.lineId;})) {
                    this.lineId = first;
                }
            }


            try {
                let eipPriceData = this.formattedPriceData[9];
                let regionData = eipPriceData[this.regionKey];
                let billData = regionData.data[this.billType];
                let configs = [];
                _.forEach(billData.data, item => {
                    let net = _.find(item.packageInfo, ['propCode', 'net']);
                    let IpNumber = _.find(item.packageInfo, ['propCode', 'IpNumber']);
                    configs.push({
                        net,
                        IpNumber
                    });
                });
                configs.sort((a, b) => {
                    let opNet = _.get(b, 'net.propValue[0].max', 0) - _.get(a, 'net.propValue[0].max', 0);
                    if (opNet != 0) {
                        return opNet;
                    }
                    return _.get(b, 'IpNumber.propValue[0].max', 0) - _.get(a, 'IpNumber.propValue[0].max', 0);
                });
                let netObj = _.get(configs[0], 'net.propValue[0]', {});
                this.maxBandwidth = netObj.max;
                this.minBandwidth = netObj.min == 0 ? 1 : netObj.min;

                // console.log(this.lineType, 123123);
                let line = _.find(list, ['LineId', this.lineId]);
                if (line.Isp === 'vBGP') {
                    this.minBandwidth = 100;
                }

                if (this.billType == 807) {
                    this.minBandwidth = 100;
                }

                if (this.bandwidth > this.maxBandwidth || this.bandwidth < this.minBandwidth) {
                    this.bandwidth = this.minBandwidth
                }
                // hack：触发一下带宽值的变化，使拖拽条的样式变化
                let srcBandwidth = this.bandwidth;
                this.bandwidth = 1;
                this.$nextTick(() => {
                    console.log(srcBandwidth, 123)
                    this.bandwidth = srcBandwidth;
                    this.exportData();
                });
            } catch(e) {
                this.exportData();
            }

        },
        changeInstanceName(){
            if(!this.instanceName){
                return
            }
            var reg = /^[\u4e00-\u9fa5_A-Za-z0-9-]{1,64}$/
            this.errorText = reg.test(this.instanceName) ? false : true
        },
        getKeadValidWhitelist(){
            this.$store.dispatch(step2Const.ValidWhitelist,{
                params:{
                    ValidateKey: 'kead',
                    Region: this.regionKey
                }
            }).then(res => {
                if (res && res.code == 200) {
                    this.supportKead = res.validate;
                } else {
                    this.supportKead = false;
                }
            }).catch(e => {
                this.supportKead = false;
            })
        }
    }
}



